import { render, staticRenderFns } from "./KnFormHeaderRow.vue?vue&type=template&id=396d0fe8"
import script from "./KnFormHeaderRow.vue?vue&type=script&lang=js"
export * from "./KnFormHeaderRow.vue?vue&type=script&lang=js"
import style0 from "./KnFormHeaderRow.vue?vue&type=style&index=0&id=396d0fe8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports